<template>
  <div
    class="col col-lg-3 col-md-4 col-sm-6 col-12"
    v-if="notification"
    @click="enterNotificationEdit"
  >
    <div class="notification">
      <EditNotificationModal
        v-if="showModal"
        :filter="filter"
        :transfer="transfer"
        @close="exitNotificationEdit"
      />
      <div class="title">{{ notification.title }}</div>
      <div class="description" v-html="notification.summaryText"/>
    </div>
  </div>
</template>

<script>
import baseController from '../../controllers/base'
import EditNotificationModal from './EditNotificationModal'

export default {
  extends: baseController,
  components: {
    EditNotificationModal
  },
  props: ['filter', 'transfer'],
  data() {
    return { showModal: false }
  },
  computed: {
    notification() {
      return this.transfer.buildNotification(this.filter)
    }
  },
  methods: {
    loadFilters() {
      this.$emit('filterUpdated2')
    },
    enterNotificationEdit() {
      this.showModal = true
    },
    exitNotificationEdit() {
      this.showModal = false
      this.$emit('filtersChanged')
    }
  }
}
</script>
